module.exports = __webpack_public_path__ + "static/img/huai1.9cf95f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/huai1.jpg
// module id = HE8s
// module chunks = 0